module.exports = __webpack_public_path__ + "waiting-for-octopus.2230e5865e76e7a9dad4389739459174.hashedasset.svg";